/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MenuItem } from '@ebcont/ebcont.galaxy.js';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MapComponent implements OnChanges {
  @Input() selectedLocationItem: MenuItem = {} as any;

  public locationItems: Record<string, string> = {
    wien:
      '!1m18!1m12!1m3!1d2657.2447778589644!2d16.384704417443842!3d48.2404153!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!' +
      '4f13.1!3m3!1m2!1s0x476d065ae4d4d65d%3A0xaee8c05acef1feb1!2sEBCONT%20Zentrale!5e0!3m2!1sen!2sat' +
      '!4v1683904616251!5m2!1sen!2sat',
    graz:
      '!1m18!1m12!1m3!1d2717.802710682146!2d15.447512477767381!3d47.06372032530627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x476e4b403487347b%3A0x6284874de40d1571!2sEBCONT%20Zweigstelle%20Graz!5e0!3m2!1sen' +
      '!2sde!4v1757079228849!5m2!1sen!2sde',
    linz:
      '!1m18!1m12!1m3!1d2654.0412051168496!2d14.288564377796767!3d48.30205893969405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x477397856fe6fa7d%3A0x738632c9d1dcca92!2sEBCONT%20Zweigstelle%20Linz!5e0!3m2' +
      '!1sen!2sde!4v1757079310454!5m2!1sen!2sde',
    hard:
      '!1m18!1m12!1m3!1d5392.10081020148!2d9.682428198679906!3d47.48893142178737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x479b124099abc83d%3A0x9802f0ce36c36c81!2sEBCONT%20proconsult%20-%20Zweigstelle%20Hard' +
      '!5e0!3m2!1sen!2sde!4v1757079391476!5m2!1sen!2sde',
    saarbruecken:
      '!1m18!1m12!1m3!1d2604.9127194274256!2d6.992629677819677!3d49.240143973763914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x4795b74904ac642d%3A0x8aad7c5321cebe4b!2sEBCONT%20informatics%20GmbH%20Zweigstelle%20' +
      'Saarbr%C3%BCcken!5e0!3m2!1sen!2sde!4v1757079472680!5m2!1sen!2sde',
    newyork:
      '!1m18!1m12!1m3!1d3022.390772386931!2d-73.98569632812716!3d40.753429214779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x89c2590086e320fb%3A0xa6dc2b6c0f731899!2s501%205th%20Ave%201607%20501%2C%20New%20' +
      'York%2C%20NY%2010017%2C%20USA!5e0!3m2!1sen!2sde!4v1757079544990!5m2!1sen!2sde',
    stpoelten:
      '!1m18!1m12!1m3!1d2658.999281275962!2d15.625631277693657!3d48.206629771251144!2m3!1f0!2f0!3f0!3m2!1i1024' +
      '!2i768!4f13.1!3m3!1m2!1s0x477278a91e1b6b09%3A0x375025230ecbdaeb!2sKlostergasse%2031%2C%203100%20' +
      'St.%20P%C3%B6lten!5e0!3m2!1sen!2sat!4v1709109437464!5m2!1sen!2sat',
    frankfurt:
      '!1m18!1m12!1m3!1d2558.832738572387!2d8.66054317748376!3d50.108137621528854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768' +
      '!4f13.1!3m3!1m2!1s0x47bd095576d18f93%3A0x2d4fb3692f43890a!2sAm%20Hauptbahnhof%2016%2C%2060329%20' +
      'Frankfurt%20am%20Main%2C%20Germany!5e0!3m2!1sen!2sat!4v1770109915842!5m2!1sen!2sat',
    neulengbach:
      '!1m18!1m12!1m3!1d2659.6788446419832!2d15.904068999999998!3d48.193539!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x476d9de0ac17beff%3A0xe0207e4405fe3fe3!2sEBCONT%20works%20GmbH!5e0!3m2!1sen' +
      '!2sat!4v1709109847938!5m2!1sen!2sat',
    hamburg:
      '!1m18!1m12!1m3!1d2370.4369071592396!2d10.001840477929461!3d53.54996775946686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1'+
      '!3m3!1m2!1s0x47b18ee3baee0d57%3A0x83978a1b0698cc2b!2sSteinstra%C3%9Fe%205-7%2C%2020095%20Hamburg!5e0!3m2!1sen'+
      '!2sde!4v1757079636652!5m2!1sen!2sde',
    berlin:
      '!1m18!1m12!1m3!1d4853.934207418674!2d13.359427599595493!3d52.534029363164834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1'+
      '!3m3!1m2!1s0x47a8519a58c52dcf%3A0x1f442ed254c90049!2sHeidestra%C3%9Fe%2034%2C%2010557%20Berlin!5e0!3m2!1sen' +
      '!2sde!4v1757079725608!5m2!1sen!2sde',
    salzburg:
      '!1m18!1m12!1m3!1d2678.8178447964624!2d13.036684577785353!3d47.82374737295547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x477691adbd3cd69b%3A0x1830640c4009278e!2sEBCONT%20Zweigstelle%20Salzburg!5e0!3m2!1sen' +
      '!2sde!4v1757079801040!5m2!1sen!2sde',
    pinkafeld:
      '!1m18!1m12!1m3!1d2702.0774565081542!2d16.12033717777466!3d47.37140670418712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x476e89ca6ecaed2b%3A0xc1df0b235bded898!2sEBCONT%20Zweigstelle%20Pinkafeld!5e0!3m2!1sen' +
      '!2sde!4v1757079861213!5m2!1sen!2sde',
    innermanzing:
      '!1m18!1m12!1m3!1d2661.362448004168!2d15.887634777409025!3d48.16109537124608!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x476d9bba4ff16549%3A0x4c095d7d185a21fc!2sGiessh%C3%BCblstra%C3%9Fe%2024%2C%203052%20Mannersdorf' +
      '%2C%20Austria!5e0!3m2!1sen!2sde!4v1757324121331!5m2!1sen!2sde',
    cakovec:
      '!1m18!1m12!1m3!1d1375.9449028796564!2d16.44756163913429!3d46.391410592776055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x4768adbd93584a85%3A0x54082fdb1c4a2d87!2sUl.%20bana%20Josipa%20Jela%C4%8Di%C4%87a%2022b%2C%2040000' +
      '%2C%20%C4%8Cakovec%2C%20Croatia!5e0!3m2!1sen!2sde!4v1757324421571!5m2!1sen!2sde',
    viennasouth:
      '!1m18!1m12!1m3!1d2660.9287348236767!2d16.33035077779367!3d48.169454748939344!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1' +
      '!3m3!1m2!1s0x476da843e4ea646f%3A0xcaa5d16b9017899e!2sGeb%C3%A4ude%20J%2C%20Kranichberggasse%202%2C%201120%20Wien' +
      '%2C%20Austria!5e0!3m2!1sen!2sde!4v1757326340225!5m2!1sen!2sde'
  };

  public path: SafeResourceUrl = this.createPath(this.locationItems['vienna']);

  protected createPath(param: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(
      `https://www.google.com/maps/embed?pb=${param}&loading=async`
    );
  }

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedLocationItem'] && changes['selectedLocationItem'].currentValue) {
      this.selectedLocationItem = changes['selectedLocationItem'].currentValue;
      this.path = this.createPath(this.locationItems[this.selectedLocationItem.id]);
    }
  }
}
